import { HttpHandlerFn, HttpRequest } from '@angular/common/http';

import { shouldSendCredentials } from './auth-http.helpers';

export function authWithCredentialsInterceptor(request: HttpRequest<any>, next: HttpHandlerFn) {
  return next(shouldSendCredentials(request.url)
    ? request.clone({ withCredentials: true })
    : request);
}
